
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship-managers",
      function () {
        return require("private-next-pages/ship-managers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ship-managers"])
      });
    }
  